module.exports = __webpack_public_path__ + "img/src/components/ContactForm/call.png?174016f8";